import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupsIcon from '@mui/icons-material/Groups';
import ClassIcon from '@mui/icons-material/Class';
import SchoolIcon from '@mui/icons-material/School';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import MenuBookIcon from '@mui/icons-material/MenuBook';

/**
 * HOD read-only oversight navigation (UX-DR1, UX-DR2). Intervention is the flagship entry.
 * Every destination is a read-only surface — there are NO create/edit/delete nav items.
 * Ordering: Dashboard, Intervention (flagship), Students, Batches, Faculty, Mock Interviews,
 * Faculty Diary (metrics). Assignments/Reports placement is UX-Deferred-01.
 */
export function getHodNavSections() {
  return [
    {
      id: 'hod-oversight',
      title: 'Oversight',
      initiallyExpanded: true,
      items: [
        { id: 'hod-dashboard', label: 'Dashboard', path: '/hod/dashboard', icon: React.createElement(DashboardIcon) },
        { id: 'hod-intervention', label: 'Intervention', path: '/hod/intervention', icon: React.createElement(WarningAmberIcon) },
        { id: 'hod-students', label: 'Students', path: '/hod/students', icon: React.createElement(GroupsIcon) },
        { id: 'hod-batches', label: 'Batches', path: '/hod/batches', icon: React.createElement(ClassIcon) },
        { id: 'hod-faculty', label: 'Faculty', path: '/hod/faculty', icon: React.createElement(SchoolIcon) },
        { id: 'hod-mock-interviews', label: 'Mock Interviews', path: '/hod/mock-interviews', icon: React.createElement(RecordVoiceOverIcon) },
        { id: 'hod-diary-metrics', label: 'Faculty Diary (metrics)', path: '/hod/diary-metrics', icon: React.createElement(MenuBookIcon) },
      ],
    },
  ];
}
